import {Factory} from './Factory'
import { TabFactory } from './TabFactory'
import Menu from '../EditorComponents/PopUp/Menu'
export class PopUpFactory extends Factory {
  constructor(qty = 1) {
    super()
    this.qty = qty
  }

  object() {
    return {
      id: this.id('pop-up'),
      slug: 'editor-pop-up',
      "assets": {
        "phone": [],
        "tablet": [],
        "desktop": []
      },
      "background": {
        "phone": "color",
        "tablet": "color",
        "desktop": "color"
      },
      "customClasses": [],
      "constantClasses": {
        "phone": [],
        "tablet": [],
        "desktop": []
      },
      "containerClasses":{
        "phone": [],
        "tablet": [],
        "desktop":[]
      },
      sections: (new TabFactory).create(),
      "name":"PopUp",
    }
  }

  properties() {
    return {
      content: [
        {key: 'name', component:'ContentText', text:'name', property:'name'},
        {key: 'open-on-leave', component:'ContentToggle', text:'Open on Leave', property:'openOnLeave'},
        {key: 'timeout', component:'ContentToggle', text:'Open Timeout', property:'timeOut'},
        {key: 'timeout-time', component:'ContentText', text:'milliseconds', property:'timeOutTime'},
      ],
      styles: [
        {key: 'width', component: 'PopUpCustomWidth'},
        {key: 'position', component: 'FixedPositionProperty', class: 'containerClasses'},
        {key: 'rounded', component: 'RoundedProperty', class: 'containerClasses'},
        {key: 'border', component: 'BorderProperty', class: 'containerClasses'},
        {key: 'shadow', component: 'ShadowProperty', class: 'containerClasses'},
      ],
      advanced: [
        {key: 'element-id', component: 'ElementId'},
        {key: 'custom-classes', component: 'CustomClasses'},
        {key: 'custom-styles', component: 'CustomStyles'},
      ],
      menu: Menu
    }
  }
}